import { resetGrafanaSessionMetadata } from '../web-tracing';
import { clearDexieAndQueryClient, clearTokens } from './cache/utils';

// Channel name for cross-tab communication
const AUTH_CHANNEL = 'secoda-auth-channel';

// Event types
export type AuthEventType =
	| 'SIGN_IN'
	| 'SIGN_OUT'
	| 'IMPERSONATION_START'
	| 'IMPERSONATION_END'
	| 'SWITCH_WORKSPACE';

interface AuthEvent {
	type: AuthEventType;
	redirectPath?: string;
}

// Create a broadcast channel for auth events
const authChannel = new BroadcastChannel(AUTH_CHANNEL);

// Function to handle auth events
const handleAuthEvent = async (event: AuthEvent) => {
	try {
		await clearDexieAndQueryClient();
		clearTokens();
		localStorage.clear();
		resetGrafanaSessionMetadata();
		window.location.href = event.redirectPath || '/';
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('Error handling auth event:', error);
	}
};

// Function to broadcast auth events to all tabs
export const broadcastAuthEvent = (event: AuthEvent) => {
	authChannel.postMessage(event);
};

export const processAuthEvent = (event: AuthEvent) => {
	handleAuthEvent(event);
	broadcastAuthEvent(event);
};

// Set up event listener for auth events
authChannel.onmessage = (event: MessageEvent<AuthEvent>) => {
	handleAuthEvent(event.data);
};
